module.exports = ".bg-soul {\n  background-color: #141414; }\n\n.nav-item, .navbar-brand {\n  cursor: pointer; }\n\n.navbar-brand {\n  color: white !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/navbar/navbar.component.scss
// module id = ./src/app/shared/navbar/navbar.component.scss
// module chunks = main